<template>
  <div>
	  <Header :sel='3' @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	      <div class="banner">

  </div>
  <!--banner--> 
  
  <!--neirong-->
   <div class="bread_bg"><div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)">案例展示</a>- <a
						href="javascript:void(0)">{{categoryName? categoryName : '全部'}} </a></div></div>
  <div class="neirong">
  <div class="fenlei_bg">
  <div class="fenlei_l"><b>快速检索案例</b>  <a href="javascript:void(0)" @click="selData(item.categoryCode,item.categoryName)" :class="item.categoryCode==categoryCode?'selected0':''" v-for="item in tabList" :key="item.value">{{item.categoryName}}</a></div>

 <div class="fenlei_r">
          <input name="" type="text"  v-model="categoryName" placeholder="搜索智慧工会案例" class="search_txt2"/>
          <input name="" type="button"  class="search_but2" @click="search"/>

        </div>
  </div>
<ul class="case_list_n">
          <li v-for="item in list"> <a href="javascript:void(0)" @click="goDetail(item.id)"><img :src="item.image" />
            <div class="case_biaoqian"><span class="bq_red">{{item.clientName}}</span><span class="bq_blue" @click.stop="goSolutionList(item.categoryCode.split(',')[0],item.categoryName.split(',')[0])">{{item.categoryName.split(',')[0]}}</span><span class="bq_green" @click.stop="goSolutionDetail(item.moduleCode.split(',')[0])">{{item.moduleName.split(',')[0]}}</span></div>
            <div class="case_t">{{item.caseName}}</div>
            <div class="case_c">{{item.introduction}}</div>
            </a> </li>
          
        <div class="pick"></div>
        </ul>
	        <ul id="page">
	            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
	            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
	            <li class="total">共{{totalPage}}页</li>
	        </ul>
	      </div>
	    </div>
	         <Footer></Footer> 
	   
	  </div>
	  
    
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getSolutionList,getCaseList} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			id: '',
			name: '',
			tabList:[],
			selName:'全部新闻',
			selid:'0',
			list:[],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
			categoryName:'',
            categoryCode:'',
		}
  	},
	created() {
			this.categoryCode = this.$route.query.id
			this.categoryName = this.$route.query.name
		
		},
  	mounted() {
		
	  this.getSolutionList()
	  this.getData()
  	},

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		},
		selData(id,name){
			this.categoryCode=id;
			this.categoryName=name;
			this.search()
		},
		search(){
			this.pageNum=1;
			this.getData()
		},
		getSolutionList(){
			getSolutionList({
				categoryCode: '2000',
			}).then(res => {
				res.data.unshift({
					categoryName:'全部',
                    categoryCode:'',
				})
				this.tabList = res.data;
			});
		},

		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
		            left = this.pageNum - 1
		            right = this.pageNum + 1
		        } else {
		            if (this.pageNum <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNum = 1
		    } else if (type == 'end') {
		        this.pageNum = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNum > 1) {
		            this.pageNum = this.pageNum - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNum < (this.totalPage)) {
		            this.pageNum = this.pageNum + 1
		        }
		    } else {
		        this.pageNum = type
		    }
		    this.getData()
		},
		getData(){
			let par={
				categoryCode:this.categoryCode?this.categoryCode : '',
				pageNumber: this.pageNum,
				categoryName:this.categoryName? this.categoryName : '',
				pageSize: 6,
				
			}
			getCaseList(par).then(res => {
			  this.list = res.data.list;
			  this.totalPage = Math.ceil(res.data.totalRow / 6)
			  this.checkIndex();
			});
		},
		goDetail(id){
			this.$router.push({
				path:'/caseDetail',
				query:{id:id}
			})
		},
		goSolutionList(id,name){
			this.$router.push({
				path:'/solutionList',
				query:{id:id,name:name}
			})
		},
		goSolutionDetail(id){
			this.$router.push({
				path:'/solutionDetail',
				query:{id:id}
			})
		},     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_10.jpg');
	}


</style>
